import React, { FC } from 'react';

import { PaymentConceptTextProps } from './types';
import styles from './styles.module.css';

export const PaymentConceptText: FC<PaymentConceptTextProps> = ({
  name,
  label,
  value,
}) => {
  return (
    <div
      className={styles.paymentConcept}
      data-testid={`payment-concept-${name}`}
    >
      <span className={styles.conceptLabel}>{label}</span>
      <span className={styles.conceptTextValue}>{value}</span>
    </div>
  );
};
